import { render, staticRenderFns } from "./ModifyView.vue?vue&type=template&id=915a3e1a&scoped=true&"
import script from "./ModifyView.vue?vue&type=script&lang=js&"
export * from "./ModifyView.vue?vue&type=script&lang=js&"
import style0 from "./ModifyView.vue?vue&type=style&index=0&id=915a3e1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915a3e1a",
  null
  
)

export default component.exports